export const activityIndicatorStyles = {
  root: "mb-1",
  summary:
    "group flex w-full items-center gap-2 rounded-md py-1 pl-2 pr-2 text-left transition-colors hover:bg-background/50 focus:outline-none",
  summarySparkle: "shrink-0 animate-spin",
  summaryText: "flex min-w-0 flex-1 items-baseline gap-1.5",
  summaryLabel: "shrink-0 text-xs font-medium text-muted-foreground",
  summaryDetail: "truncate text-xs text-subtle",
  chevron:
    "h-3.5 w-3.5 shrink-0 text-subtle opacity-40 transition-opacity duration-200 group-hover:opacity-100",
  list: "mt-0.5 space-y-1 pb-1 pl-5",
  step: "flex items-baseline gap-2",
  stepIcon: "flex h-4 w-3 shrink-0 translate-y-0.5 items-center",
  check: "text-subtle",
  stepSparkle: "animate-spin",
  stepText: "min-w-0 flex-1",
  stepLabel: "text-xs font-medium text-mid",
  stepDetail: "block text-xs leading-snug text-subtle",
};
